// src/components/CategorySelector.js
import React, { useState } from 'react';
import './CategorySelector.css';

const OPTIONS = [
  { label: 'All Projects', value: '' },
  { label: 'Luxury',              value: 'luxury' },
  { label: 'Automotive',   value: 'automotive' },
  { label: 'Beauty',       value: 'beauty' },
  { label: 'Fashion',      value: 'fashion' },
  { label: 'Food & Beverage',    value: 'food_beverage' },
  { label: 'Home',         value: 'home' },
  { label: 'Tech',         value: 'tech' },
  { label: 'Aviation',     value: 'aviation' },
  { label: 'Travel',       value: 'travel' },
  { label: 'Comedy',       value: 'comedy' },
  { label: 'Sport',        value: 'sport' },

];

export default function CategorySelector({ category, onChange }) {
  const [open, setOpen] = useState(false);
  const currentLabel = OPTIONS.find(opt => opt.value === category)?.label || 'All Projects';

  const handleSelect = (value) => {
    onChange(value);
    setOpen(false);
  };

  return (
    <div className="category-selector">
      <button
        className="selector-button"
        onClick={() => setOpen(o => !o)}
      >
        {currentLabel}
      </button>

      {open && (
        <>
          <div
            className="selector-overlay"
            onClick={() => setOpen(false)}
          />

          <ul className="selector-dropdown">
            {OPTIONS.map(opt => (
              <li
                key={opt.value || 'all'}
                onClick={() => handleSelect(opt.value)}
              >
                {opt.label}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}